import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, finalize, throwError } from 'rxjs';
import { AppService } from '../services/app.service';
import { DmsProblemDetails } from '../services/client.service';

let activeRequests = 0;

export const authInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const appService = inject(AppService);
  const excludedUrls: string[] = ["ChecklistReport"];

  const shouldExclude = excludedUrls.some(url => request.url.includes(url));
  if (!shouldExclude) {
    activeRequests++;
    appService.setLoading(true);
  }

  const clonedRequest = request.clone({
    headers: request.headers.append('Access-Control-Allow-Origin', "*")
  });

  return next(clonedRequest).pipe(
    finalize(() => {
      if (!shouldExclude) {
        activeRequests--;
        if (activeRequests === 0) {
          appService.setLoading(false);
        }
      }
    }),
    catchError((err: any) => {
      if (err.error) {
        getProblemDetails(err).subscribe(
          problemDetails => appService.handleErrorMessage(problemDetails.detail),
          () => appService.handleErrorMessage(err.detail)
        );
      } else {
        appService.handleErrorMessage(err.error?.detail);
      }
      return throwError(() => err);
    })
  );
};

function getProblemDetails(err: HttpErrorResponse): Observable<DmsProblemDetails> {
  return new Observable<DmsProblemDetails>(observer => {
    if (!err.error) {
      observer.error(err);
      observer.complete();
      return;
    }
    const reader = new FileReader();
    reader.onload = event => {
      try {
        const problemDetails = JSON.parse((event.target as any).result);
        observer.next(problemDetails);
      } catch {
        observer.error(err);
      } finally {
        observer.complete();
        return;
      }
    };
    reader.readAsText(err.error);
  });
}
